import { css } from '@emotion/react';
import { PREFIX } from '../utils/index.ts';
import { SPACINGS } from './constants.ts';

export const APP_SPACINGS = css(
  Object.entries(SPACINGS).reduce(
    (acc, [key, value]) => `${acc}${PREFIX.SPACING}${key}: ${value || 'none'};`,
    ''
  )
);
